import React, { useEffect } from 'react'
import styled from 'styled-components'
import api from '../../api'
import { Container } from '../../assets/styles/GlobalStyle'
import Loader from '../../components/Loader'
import RichText from '../../components/RichText'

const TermsAndConditions: React.FC<{
  dialog?: boolean
}> = ({ dialog = false }) => {
  //
  const { data: webDocuments, isLoading: isWebDocumentsLoading } = api.useGetWebPageQuery('terms-and-conditions')
  //
  // scroll to top
  useEffect(() => {
    window.scrollTo(0, 0)
    //
    return () => {}
  }, [])
  //
  //
  return isWebDocumentsLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      {dialog ? (
        <DialogBlock>
          <RichText html={webDocuments?.body || ''} />
        </DialogBlock>
      ) : (
        <Container>
          <Content>
            <RichText html={webDocuments?.body || ''} />
          </Content>
        </Container>
      )}
    </Wrapper>
  )
}
//
const DialogBlock = styled.div`
  position: absolute;
  z-index: 111111111111;
  background-color: #fafbfb;
  padding: 20px;
`
const Content = styled.div`
  padding-block: 50px;
`
const Wrapper = styled.div``
//
export default TermsAndConditions
